import { lazy } from "react";
import { RequirePermission } from "../components/RequirePermission";
import { Navigate, Route } from "react-router";
import { StoreRedirect } from "../features/store/StoreRedirect";

const BookingsPage = lazy(() =>
  import("../features/bookings/list/BookingsPage").then((m) => ({ default: m.BookingsPage })),
);
const ServicesPage = lazy(() =>
  import("../features/bookings/services/ServicesPage").then((m) => ({ default: m.ServicesPage })),
);
const BookingSettingsPage = lazy(() =>
  import("../features/bookings/settings/SettingsPage").then((m) => ({
    default: m.BookingSettingsPage,
  })),
);
const StaffPage = lazy(() =>
  import("../features/bookings/staff/StaffPage").then((m) => ({ default: m.StaffPage })),
);
const WaitlistPage = lazy(() =>
  import("../pages/bookings/waitlist").then((m) => ({ default: m.WaitlistPage })),
);
const AutomationHubPage = lazy(() =>
  import("../features/automations/hub/AutomationHubPage").then((m) => ({
    default: m.AutomationHubPage,
  })),
);
const EcommercePackPage = lazy(() =>
  import("../features/automations/ecommerce/EcommercePackPage").then((m) => ({
    default: m.EcommercePackPage,
  })),
);
const AutomationSettingsPage = lazy(() =>
  import("../features/automations/settings/AutomationSettingsPage").then((m) => ({
    default: m.AutomationSettingsPage,
  })),
);
const FlowControlPage = lazy(() =>
  import("../features/flow-control/FlowControlPage").then((m) => ({
    default: m.FlowControlPage,
  })),
);
const FlowErrorsPage = lazy(() =>
  import("../features/flow-errors/FlowErrorsPage").then((m) => ({
    default: m.FlowErrorsPage,
  })),
);
const AutomationAnalyticsPage = lazy(() =>
  import("../features/automations/analytics/AutomationAnalyticsPage").then((m) => ({
    default: m.AutomationAnalyticsPage,
  })),
);
const OrderLifecyclePage = lazy(() =>
  import("../features/automations/order-lifecycle/OrderLifecyclePage").then((m) => ({
    default: m.OrderLifecyclePage,
  })),
);
const ReconciliationPage = lazy(() =>
  import("../features/payments/reconciliation/ReconciliationPage").then((m) => ({
    default: m.ReconciliationPage,
  })),
);
const BuilderCopilotPage = lazy(() =>
  import("../features/automation/copilot/BuilderCopilotPage").then((m) => ({
    default: m.BuilderCopilotPage,
  })),
);

// Route order inside <Route path="/w/:workspaceId"> is preserved: this fragment slots in where it was inline.
export const workspaceBookingsRoutes = (
  <>
    <Route
      path="bookings"
      element={
        <RequirePermission anyOf={["commerce.view"]} module="bookings">
          <BookingsPage />
        </RequirePermission>
      }
    />
    <Route
      path="bookings/services"
      element={
        <RequirePermission anyOf={["commerce.view"]} module={["bookings", "services"]}>
          <ServicesPage />
        </RequirePermission>
      }
    />
    <Route
      path="bookings/staff"
      element={
        <RequirePermission anyOf={["commerce.view"]} module="bookings">
          <StaffPage />
        </RequirePermission>
      }
    />
    <Route
      path="bookings/waitlist"
      element={
        <RequirePermission anyOf={["commerce.view"]} module="bookings">
          <WaitlistPage />
        </RequirePermission>
      }
    />
    <Route
      path="bookings/settings"
      element={
        <RequirePermission anyOf={["commerce.view"]} module="bookings">
          <BookingSettingsPage />
        </RequirePermission>
      }
    />
    <Route path="quotes" element={<StoreRedirect to="store/quotes" />} />
    <Route path="quotes/settings" element={<StoreRedirect to="store/quotes/settings" />} />
    {/* OWN-370: one «ابدأ» page */}
    <Route
      path="automation"
      element={<Navigate replace to="../getting-started" relative="path" />}
    />
    <Route path="automation/copilot" element={<BuilderCopilotPage />} />
    <Route
      path="automations"
      element={
        <RequirePermission anyOf={["flows.view"]}>
          <AutomationHubPage />
        </RequirePermission>
      }
    />
    <Route path="automations/order-lifecycle" element={<OrderLifecyclePage />} />
    <Route path="automations/ecommerce" element={<EcommercePackPage />} />
    <Route path="automations/settings" element={<AutomationSettingsPage />} />
    <Route path="automations/control" element={<FlowControlPage />} />
    <Route
      path="automations/errors"
      element={
        <RequirePermission anyOf={["flows.view"]}>
          <FlowErrorsPage />
        </RequirePermission>
      }
    />
    <Route path="automations/analytics" element={<AutomationAnalyticsPage />} />
    <Route path="payments" element={<StoreRedirect to="store/payments" />} />
    <Route path="payments/reconciliation" element={<ReconciliationPage />} />
  </>
);
